import { usePostLayoutSize } from '../../utils/responsive/PostLayoutSizeProvider';

const useIsPostTopicBarLarge = () => {
  const postLayoutSize = usePostLayoutSize();
  return !['mobile', 'tablet'].includes(postLayoutSize);
};

export default useIsPostTopicBarLarge;
